import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramHashtagFeedPostsV2.graphql';
import { Query, QueryinstagramHashtagFeedPostsV2Args } from '../../__generated__/globalTypes';

export const useInstagramHashtagFeedPostsV2Query = (
  options?: QueryHookOptions<Query, QueryinstagramHashtagFeedPostsV2Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramHashtagFeedPostsV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramHashtagFeedPostsV2LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramHashtagFeedPostsV2Args>
): QueryResult<Query, QueryinstagramHashtagFeedPostsV2Args> & {
  getInstagramHashtagFeedPostsV2: LazyQueryExecFunction<Query, QueryinstagramHashtagFeedPostsV2Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramHashtagFeedPostsV2, result] = useLazyQuery<Query, QueryinstagramHashtagFeedPostsV2Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramHashtagFeedPostsV2, ...result };
};

export const useInstagramHashtagFeedPostsV2PromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramHashtagFeedPostsV2 = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramHashtagFeedPostsV2Args, Query>, 'query'>) =>
      client.query<Query, QueryinstagramHashtagFeedPostsV2Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramHashtagFeedPostsV2 };
};
// Suspense Query Hooks
export const useInstagramHashtagFeedPostsV2SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramHashtagFeedPostsV2Args>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramHashtagFeedPostsV2Args>(QUERY, {
    ...options
  });

  return result;
};
